import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full border-y border-cream-300 bg-cream-100 px-4 py-16" data-id="element-66" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto max-w-xl text-center" data-id="element-67" data-mp="223el1k29z72x">
        <span className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-brand/25 bg-white" data-id="element-68" data-mp="2223ghi109var">
          <ShieldCheckIcon className="h-5 w-5 text-brand" aria-hidden="true" data-id="element-69" data-mp="1x28rxl4pdhsv" />
        </span>

        <h2 className="mt-5 font-display text-[19px] font-black uppercase tracking-[0.06em] text-ink sm:text-[22px]" data-id="element-70" data-mp="19f0qjeaeasw4">
          Garanzia &ldquo;Soddisfatti o rimborsati&rdquo;
        </h2>

        <p className="mx-auto mt-4 max-w-md font-sans text-[13px] leading-relaxed text-ink-soft" data-id="element-71" data-mp="1j654qbs8y9pw">
          Prova il pacchetto per 30 giorni interi, porta le schede in classe e guarda come
          reagiscono i bambini. Se non è quello che ti aspettavi, ti restituiamo ogni centesimo:
          basta una mail, senza moduli e senza spiegazioni.
        </p>

        <p className="mt-5 font-sans text-[11px] font-bold uppercase tracking-[0.16em] text-brand" data-id="element-72" data-mp="p01edzh2un61">
          Il rischio è tutto nostro, non tuo
        </p>
      </div>
    </section>;
}